import { useState } from "react";
import WhatsAppKeyContext from "./WhatsAppKeyContext";
const WhatsAppKeyState = (props) => {
  const [dialog, setDialogs] = useState(false);
  const [formData, setFormData] = useState({
    wpApiKey: "",
    wpApiSecret: "",
  });

  return (
    <>
      <WhatsAppKeyContext.Provider
        value={{
          dialog,
          setDialogs,
          formData,
          setFormData,
        }}
      >
        {props.children}
      </WhatsAppKeyContext.Provider>
    </>
  );
};

export default WhatsAppKeyState;
